import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../scss/dashboard/dashSlider.css";
import {
  CarouselControl,
  Carousel,
  CarouselItem,
  CarouselIndicators,
} from "reactstrap";
import Imagen3 from "../../images/dashboardAbogados/Imagen3.svg";
function AltInicioslider() {
  // State for Active index
  const [activeIndex, setActiveIndex] = React.useState(0);

  // State for Animation
  const [animating, setAnimating] = React.useState(false);

  // Sample items for Carousel
  const items = [
    {
      caption: "Sample Caption One",
      src: "https://media.geeksforgeeks.org/wp-content/uploads/20210425122739/2-300x115.png",
      altText: "Slide One",
    },
    {
      caption: "Sample Caption Two",
      src: "{ Imagen3 }",
      altText: "Slide Two",
    },
    {
      caption: "Sample Caption One",
      src: "https://media.geeksforgeeks.org/wp-content/uploads/20210425122739/2-300x115.png",
      altText: "Slide One",
    },
    {
      caption: "Sample Caption Two",
      src: "{ Imagen3 }",
      altText: "Slide Two",
    },
    {
      caption: "Sample Caption Two",
      src: "{ Imagen3 }",
      altText: "Slide Two",
    },
  ];

  // Items array length
  const itemLength = items.length - 1;

  // Previous button for Carousel
  const previousButton = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? itemLength : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  // Next button for Carousel
  const nextButton = () => {
    if (animating) return;
    const nextIndex = activeIndex === itemLength ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  // Carousel Item Data
  const carouselItemData = items.map((item) => {
    return (
      <CarouselItem
        key={item.src}
        className="Slider-Item_abogados altSliderAbogados"
        onExited={() => setAnimating(false)}
        onExiting={() => setAnimating(true)}
      >
        <div>
          <div>
            <p className="altInicioSlider__p--month">Noviembre</p>
            <p className="altInicioSlider__p--date">1 Nov 2020 - 30 Nov 2020</p>
          </div>
          <div className="altInicioSlider__income">
            <p className="altInicioSlider__p--cash">$628.92</p>
            <p className="altInicioSlider__p--ingresos">Ingresos</p>
          </div>
        </div>
      </CarouselItem>
    );
  });

  return (
    <div
      style={{
        display: "block",
        width: 270,
        padding: 0,
      }}
    >
      <Carousel
        previous={previousButton}
        next={nextButton}
        activeIndex={activeIndex}
      >
        {carouselItemData}
        <CarouselControl
          directionText="Prev"
          direction="prev"
          className="Carousel--dash AltCarousel--dash"
          onClickHandler={previousButton}
        />
        <CarouselControl
          directionText="Next"
          direction="next"
          className="Carousel--dash AltCarousel--dash"
          onClickHandler={nextButton}
        />
      </Carousel>
    </div>
  );
}

export default AltInicioslider;
